var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCalendarArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.611 5.079a.75.75 0 0 1 1.06.032l6 6.375a.75.75 0 0 1 0 1.028l-6 6.375a.75.75 0 0 1-1.092-1.028L15.095 12 9.58 6.139a.75.75 0 0 1 .032-1.06",
  clipRule: "evenodd"
})));
export default SvgIconCalendarArrow;